var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "conteneurLead",
      staticStyle: { width: "100%" },
      attrs: { flat: "" }
    },
    [
      _c(
        "v-card-title",
        {
          staticClass: "primary white--text",
          staticStyle: { height: "52px", padding: "0px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("justCloseDialogConfirm")
                }
              }
            },
            [_c("v-icon", { staticClass: "white--text" }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "title tf_title_dialog",
            domProps: { innerHTML: _vm._s(_vm.titleDialogConfirm) }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", md4: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.sectionOptions,
                      "item-text": "text",
                      "item-value": "id",
                      label: "Section"
                    },
                    model: {
                      value: _vm.selectedSection,
                      callback: function($$v) {
                        _vm.selectedSection = $$v
                      },
                      expression: "selectedSection"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.versions,
              loading: _vm.loadingData,
              "rows-per-page-items": [10, 25, 50]
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function(props) {
                  return [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openVersion(props.item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(props.item.date))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openVersion(props.item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(props.item.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openVersion(props.item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(props.item.comment))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openVersion(props.item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(props.item.who))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openVersion(props.item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(props.item.llm))]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            props.item["tokens_" + _vm.selectedSection] ||
                              props.item.tokens ||
                              0
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-xs-right" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", flat: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.openVersion(props.item)
                                }
                              }
                            },
                            [_vm._v("Voir")]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "90%" },
          model: {
            value: _vm.showCompareDialog,
            callback: function($$v) {
              _vm.showCompareDialog = $$v
            },
            expression: "showCompareDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.closeCompareDialog }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "title" }, [
                    _vm._v("Historique prompt CSAT")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "pr-3", attrs: { xs12: "", md6: "" } },
                        [
                          _c("h3", { staticClass: "mb-2" }, [
                            _vm._v("Prompt actuel")
                          ]),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.currentPromptValue(),
                              readonly: "",
                              "auto-grow": "",
                              rows: "12",
                              outline: ""
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pl-3", attrs: { xs12: "", md6: "" } },
                        [
                          _c("h3", { staticClass: "mb-2" }, [
                            _vm._v("Version historisee")
                          ]),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.historicPromptValue(),
                              readonly: "",
                              "auto-grow": "",
                              rows: "12",
                              outline: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", disabled: !_vm.selectedVersion },
                      on: {
                        click: function($event) {
                          _vm.showRenameDialog = true
                        }
                      }
                    },
                    [_vm._v("Renommer")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        flat: "",
                        color: "error",
                        disabled: !_vm.selectedVersion
                      },
                      on: { click: _vm.confirmDeleteVersion }
                    },
                    [_vm._v("Supprimer")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: { click: _vm.closeCompareDialog }
                    },
                    [_vm._v("Fermer")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        disabled: !_vm.selectedVersion
                      },
                      on: { click: _vm.restoreSelectedSection }
                    },
                    [_vm._v("Restaurer section")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        disabled: !_vm.selectedVersion
                      },
                      on: { click: _vm.restoreAllSections }
                    },
                    [_vm._v("Restaurer tout")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "560", persistent: "" },
          model: {
            value: _vm.showRenameDialog,
            callback: function($$v) {
              _vm.showRenameDialog = $$v
            },
            expression: "showRenameDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Renommer la version")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: { label: "Nom" },
                    model: {
                      value: _vm.renamePromptName,
                      callback: function($$v) {
                        _vm.renamePromptName = $$v
                      },
                      expression: "renamePromptName"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-textarea", {
                    attrs: { label: "Commentaire", "auto-grow": "", rows: "4" },
                    model: {
                      value: _vm.renamePromptComment,
                      callback: function($$v) {
                        _vm.renamePromptComment = $$v
                      },
                      expression: "renamePromptComment"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showRenameDialog = false
                        }
                      }
                    },
                    [_vm._v("Annuler")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.loadingRename },
                      on: { click: _vm.submitRenameVersion }
                    },
                    [_vm._v("Enregistrer")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63a1c333", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a1c333","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzDialogVersionPromptCsat.vue
// module id = null
// module chunks = 